import React from 'react'
import { useRef, useEffect } from 'react';
import '../sass/modal.sass';
import closeBtn from '../img/close.svg'

function Modal ({title, content, closeModal, isOpen}) {
    const myRef = useRef();

    useEffect(() => {
        const handleClickOutside = e => {
            if (myRef.current.offsetParent != null && !myRef.current.contains(e.target)) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [closeModal]);

    return (
        <div className={`modalContainer ${isOpen ? "modalOpen" : ""}`}>
            <div ref={myRef} className={`modalBox ${isOpen ? "open" : ""}`}>
                <div className="closeModal" onClick={closeModal}>
                    <img src={closeBtn} alt="close-button" />
                </div>
                <h2 className="modalBoxTitle mt-0">{title}</h2>
                <div className="modalBoxContent">{content}</div>
            </div>
        </div>
    )
}

export default Modal